import { render, staticRenderFns } from "./Card-v2.vue?vue&type=template&id=34c210ee"
import script from "./Card-v2.vue?vue&type=script&lang=js"
export * from "./Card-v2.vue?vue&type=script&lang=js"
import style0 from "./Card-v2.vue?vue&type=style&index=0&id=34c210ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports